import { Toast } from 'vant'
import axios from 'axios'

/**
 * @author: aji
 * @description: axios封装  post/get 方法，并使用 interceptor 拦截器作 loading/toast等拦截
 * * 这里使用了 Vant Toast组件，如果不需要，可以自行修改，请修改 ToastPool
 * * interceptor 拦截器，应根据需求自行修改，如果你的业务够复杂，那 interceptor 应足够简单，如果不，那可以把匹配程度写得更细
 * * 拦截器还自动使用了 loading/error 等，一般可通过多传参来控制，如
 * `axiosP(url, data, { loading: true/false, error: true/false }) 来控制是否显示 loading/error提示`
 */

/**
 * ToastPool 池，使用 vant.Toast 组件，可自行更改
 * * 方法：show/hide/hideAll
 */
class ToastPool {
  static pool = []

  static show () {
    this.pool.push(Toast.loading({
      forbidClick: true,
      duration: 0
    }))
  }

  static hide () {
    this.pool.shift()?.clear?.()
  }

  static hideAll () {
    this.pool.forEach(item => item.clear?.())
    this.pool = []
  }
}

axios.interceptors.request.use(config => {
  const { others: { loading = false } } = config

  if (!loading) {
    ToastPool.show()
  }

  return config
}, error => {
  console.error(error)
})

axios.interceptors.response.use(resp => {
  const { config = {} } = resp
  const { others: { loading = false } } = config
  if (!loading) {
    ToastPool.hide()
  }

  return Promise.resolve(resp)
  // const { config } = resp
  // console.error(config.url)
  // console.error(config.data)
  // console.error(resp.data)
}, error => {
  const { response = {} } = error
  const { status = '' } = response
  const { config: { others: { noError = false, loading = false } = {} } = {} } = response

  if (!loading) {
    ToastPool.hide()
  }

  if (!noError) {
    let msg = '操作失败，请稍候重试'

    if (status >= 400) {
      msg = '未找到请求链接'
    } else if (status >= 500) {
      msg = '服务器错误，请稍候重试'
    }

    Toast(msg)
  }

  return Promise.reject(error)
})

/**
 * axios get 请求
 * @param url
 * @param data
 * @param others {object} { loading: true/false, error: true/false }
 * @returns {Promise<unknown>}
 */
function axiosG (url, data, others = {}) {
  const [method, params] = ['GET', data]
  return new Promise((resolve, reject) => {
    axios({
      method,
      url,
      params,
      others,
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error.response)
    })
  })
}

/**
 *
 * @param url
 * @param data
 * @param others {object} { loading: true/false, error: true/false }
 * @returns {Promise<unknown>}
 */
function axiosP (url, data, others = {}) {
  const [method] = ['POST']
  return new Promise((resolve, reject) => {
    axios({
      method,
      url,
      data,
      others,
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error.response)
    })
  })
}

export {
  axios,
  axiosP,
  axiosG,
  ToastPool,
}
